import React from 'react';
import { useIntl } from '@/i18n/hooks/useIntl';
import { default as Msg } from '@/i18n/components/FormattedMessage';

export const CustomerService = () => {
  const { t } = useIntl();
  return (
    <>
      <div role='heading' aria-level={5} className='font-heading-xsmall-regular margin-bottom-m'>
        <Msg
          id='benefits.storageService.modal.overview.request.customerService.headline'
          defaultMessage='Further questions?'
        />
      </div>
      <div className='margin-bottom-m'>
        <Msg
          id='benefits.storageService.modal.overview.request.customerService.text'
          defaultMessage='Reach out to our customer service'
        />
      </div>
      <div>
        <a
          href={`tel:${t({
            id: 'benefits.storageService.modal.overview.request.customerService.phoneNumber',
            defaultMessage: 'phone number',
          }).replaceAll(/[^0-9+]/g, '')}`}
        >
          <span className='is24-icon-telephone margin-right-s' />
          <Msg
            id='benefits.storageService.modal.overview.request.customerService.phoneNumber'
            defaultMessage='phone number'
          />
        </a>
      </div>
      <div className='font-body-small-regular margin-left-l margin-bottom-m'>
        <Msg
          id='benefits.storageService.modal.overview.request.customerService.businessHours'
          defaultMessage='business hours'
        />
        <br />
        <Msg
          id='benefits.storageService.modal.overview.request.customerService.businessHoursWeekend'
          defaultMessage='business hours'
        />
      </div>
      <div>
        <a
          href={`mailto:${t({
            id: 'benefits.storageService.modal.overview.request.customerService.email',
            defaultMessage: 'E-Mail',
          })}`}
        >
          <span className='is24-icon-message-email margin-right-s' />
          <Msg id='benefits.storageService.modal.overview.request.customerService.email' defaultMessage='E-Mail' />
        </a>
      </div>
    </>
  );
};

export default CustomerService;
